import api from '../utils/baseUrl';

export type StateOption = {
    name: string;
    code: string;
    countryIso2: string;
};

class StateService {
    async getStatesByCountry(selectedCountry: string): Promise<StateOption[]> {
        try {
            const response = await api.get(`states/${selectedCountry}`);
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            console.error('Error fetching states:', error);
            return [];
        }
    }
}

export default new StateService();
